import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import InformationDocumentsList from './InformationDocumentsList';
import Impressum from '../footer/Impressum';
import Privacy from '../footer/Privacy';

const InformationDocumentsApp = ({ match }) => {
    return (
        <Switch>
            <Route path={`${match.path}/:sourceId`} exact render={(props) => (<InformationDocumentsList {...props} />)} />

            <Route path={`${match.path}/:source/impressum`}
                component={() => <Impressum />} />
            <Route path={`${match.path}/:source/privacy`}
                component={() => <Privacy />} />

            <Redirect to={`${match.path}/1067`} />
        </Switch>
    );
};

export default InformationDocumentsApp;
